import React, { memo } from 'react';
import './RollingCounter.css';

const Digit = ({ value }) => {
    // FIX: Using 'em' units directly ensures accurate sliding regardless of container height.
    // Each digit is exactly 1.4em tall (defined in CSS).
    // To show '5', we slide up by 5 * 1.4em.
    const digitHeight = 1.4;
    const translateY = -(parseInt(value, 10) * digitHeight);

    return (
        <div className="rolling-digit-window">
            <div 
                className="rolling-digit-strip" 
                style={{ transform: `translateY(${translateY}em)` }}
            >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                    <div key={num} className="rolling-digit-val">
                        {num}
                    </div>
                ))}
            </div>
        </div>
    );
};

const RollingCounter = ({ value }) => {
    // Ensure value is a number, default to 0
    const safeValue = value ?? 0;
    
    // Convert to string to map over digits
    // Math.floor ensures we don't try to roll decimals
    const digits = Math.floor(safeValue).toString().split('');

    return (
        <div className="rolling-counter-wrapper">
            {digits.map((digit, index) => (
                <Digit key={index} value={digit} />
            ))}
        </div>
    );
};

export default memo(RollingCounter);